import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { Autocomplete, TextField, FormHelperText } from "@mui/material";

import { styled } from "@mui/styles";
import {
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import ButtonBlue from "../../../shared/buttonBlue";

import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BetweenSiteCarService from "../../../../../services/betweenSiteCar.service";
import { getEmployeesByCompany } from "../../../../../actions/employee";
import employeeService from "../../../../../services/employee.service";

const DivPlace = styled("div")({
  width: "80%",
  height: "50%",
  position: "relative",
  paddingBottom: "8px",
  "& .ButtonConfirm": {
    backgroundColor: "green",
    "&:hover": {
      backgroundColor: "darkgreen",
    },
  },
  "& .ButtonReject": {
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },
  "& .CalledButton": {
    position: "absolute",
    right: "-10px",
    bottom: "0",
  },
});

const DivInputPlace = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
});

const IconAndText = styled("div")({
  display: "flex",
  alignItems: "center",
  marginTop: "10px",
  marginBottom: "12px",
});

const LocationIcon = styled(LocationOnIcon)({
  margin: "5px",
  fontSize: "24px",
});

const RequesterIcon = styled(PersonIcon)({
  margin: "5px",
  fontSize: "24px",
});

const PhoneIcon = styled(LocalPhoneIcon)({
  margin: "5px",
  fontSize: "24px",
});

const EmailIcon = styled(MailIcon)({
  margin: "5px",
  fontSize: "24px",
});

const FormControlStyled = styled(FormControl)({
  width: "100%",
  backgroundColor: "white",
  borderRadius: "4px",
});

const DividerStyled = styled(Divider)({
  width: "95%",
  height: "2px",
  backgroundColor: "white",
});

const DivPlaceConfirm = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
});

const PlaceText = styled(Typography)({
  fontSize: "25px",
  marginTop: "-40px",
});

const EditButton = styled(Button)({
  width: "150px",
  height: "50px",
  backgroundColor: "#F4BB44",
  color: "black",
  fontSize: "20px",
  marginTop: "10px",
  "&:hover": {
    backgroundColor: "#F4BB44",
  },
});

const AssignPlace = (props) => {
  const dispatch = useDispatch();
  const { user: User } = useSelector((state) => state.auth);
  const { result: allEmployees } = useSelector((state) => state.employees);
  const { getValues, setValue, control, handleSubmit, watch, trigger } =
    useForm();
  const [confirmGettingPlace, setConfirmGettingPlace] = useState(false);
  const [confirmToPlace, setConfirmToPlace] = useState(false);
  const [siteScg, setSiteScg] = useState([]);

  const onClickSubmit = () => {};

  useEffect(async () => {
    if (!allEmployees) {
      await employeeService.getEmployeesById(User.idUser).then((res) => {
        if (res.data) {
          dispatch(getEmployeesByCompany(res.data[0].idCompany));
        }
      });
    }
    BetweenSiteCarService.getSite().then((res) => {
      if (res.data) {
        setSiteScg(res.data);
      }
    });
  }, []);

  useEffect(() => {
    if (allEmployees && User) {
      const userData = allEmployees.find(
        (employee) => employee.idEmployees === User.idUser
      );
  
      if (userData) {
        setValue("phoneRequester", userData.telephoneMobile || "");
      }
    }
  }, [allEmployees, User, setValue]);

  return (
    <Fragment>
      {User.roles.includes("ROLE_ADMIN") === true && (
        <>
          <DivPlace>
            <IconAndText>
              <RequesterIcon />
              <Typography variant="h6">ผู้จอง</Typography>
            </IconAndText>
            <Controller
              name="idRequester"
              control={control}
              defaultValue={User.idUser}
              rules={{ required: "This field is required" }}
              render={({ field, fieldState }) =>
                allEmployees && (
                  <Autocomplete
                    sx={{ backgroundColor: "white" }}
                    options={allEmployees || []}
                    getOptionLabel={(option) =>
                      option.firstname_TH && option.lastname_TH
                        ? `${option.firstname_TH} ${option.lastname_TH}`
                        : "null"
                    }
                    getOptionKey={(option) => option.idEmployees}
                    value={
                      allEmployees.find(
                        (emp) => emp.idEmployees === field.value
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      field.onChange(newValue ? newValue.idEmployees : "");
                      setValue(
                        "phoneRequester",
                        newValue?.telephoneMobile || ""
                      ); // Auto-fill phoneRequester
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ผู้จอง"
                        variant="outlined"
                        error={!!fieldState.error}
                        helperText={
                          fieldState.error && fieldState.error.message
                        }
                      />
                    )}
                  />
                )
              }
            />
          </DivPlace>
        </>
      )}
      <DivPlace>
        <IconAndText>
          <PhoneIcon />
          <Typography variant="h6">เบอร์โทรศัพท์</Typography>
        </IconAndText>
        <Controller
          name="phoneRequester"
          control={control}
          rules={{ required: "This field is required" }}
          defaultValue={""}
          render={({ field, fieldState }) =>
            allEmployees && (
              <TextField
                {...field}
                label="เบอร์โทรศัพท์"
                variant="outlined"
                fullWidth
                error={!!fieldState?.error}
                helperText={fieldState?.error?.message}
                sx={{ backgroundColor: "white" }}
              />
            )
          }
        />
      </DivPlace>
      {/* <DividerStyled /> */}
      <DivPlace>
        <IconAndText>
          <LocationIcon />
          <Typography variant="h6">จุดรับ</Typography>
        </IconAndText>
        {!confirmGettingPlace && (
          <DivInputPlace>
            <Controller
              rules={{ required: "This field is required" }}
              render={({ field, fieldState }) => (
                <FormControlStyled
                  variant="outlined"
                  error={!!fieldState.error}
                >
                  <InputLabel>จุดรับ</InputLabel>
                  <Select
                    label="จุดรับ"
                    value={field.value}
                    onChange={field.onChange}
                  >
                    {siteScg &&
                      siteScg.map((value, index) => (
                        <MenuItem key={index} value={value.idScgSite}>
                          {value.noSite !== null &&
                            `Site${value.noSite}: ${value.nameSite}`}
                          {value.noSite === null && `${value.nameSite}`}
                        </MenuItem>
                      ))}
                  </Select>
                  {fieldState.error && (
                    <FormHelperText>{fieldState.error.message}</FormHelperText>
                  )}
                </FormControlStyled>
              )}
              name="gettingPlace"
              control={control}
            />
            <ButtonBlue
              variant="contained"
              style={{ marginTop: "20px" }}
              onClick={() => {
                trigger("gettingPlace");
                const value = getValues("gettingPlace");
                if (value) {
                  setConfirmGettingPlace(true);
                }
              }}
            >
              ยืนยัน
            </ButtonBlue>
          </DivInputPlace>
        )}
        {watch("gettingPlace") !== undefined &&
          confirmGettingPlace &&
          siteScg && (
            <DivPlaceConfirm>
              <Typography variant="body1">
                {siteScg.map((value) => {
                  if (value.idScgSite === watch("gettingPlace")) {
                    if (value.noSite !== null) {
                      return `Site${value.noSite}: ${value.nameSite}`;
                    } else {
                      return value.nameSite;
                    }
                  }
                })}
              </Typography>
              <ButtonBlue
                variant="contained"
                customColor="#FF9800"
                sx={{
                  "&:hover": {
                    borderColor: "#de8500",
                    backgroundColor: "#de8500",
                  },
                }}
                onClick={() => {
                  setConfirmGettingPlace(false);
                }}
              >
                เปลี่ยน
              </ButtonBlue>
            </DivPlaceConfirm>
          )}
      </DivPlace>
      {/* <DividerStyled /> */}
      <DivPlace>
        <IconAndText>
          <LocationIcon />
          <Typography variant="h6">จุดส่ง</Typography>
        </IconAndText>
        {!confirmToPlace && (
          <DivInputPlace>
            <Controller
              rules={{ required: "This field is required" }}
              render={({ field, fieldState }) => (
                <FormControlStyled
                  variant="outlined"
                  error={!!fieldState.error}
                >
                  <InputLabel>จุดส่ง</InputLabel>
                  <Select
                    label="จุดส่ง"
                    value={field.value}
                    onChange={field.onChange}
                  >
                    {siteScg &&
                      siteScg.map((value, index) => (
                        <MenuItem key={index} value={value.idScgSite}>
                          {value.noSite !== null &&
                            `Site${value.noSite}: ${value.nameSite}`}
                          {value.noSite === null && `${value.nameSite}`}
                        </MenuItem>
                      ))}
                  </Select>
                  {fieldState.error && (
                    <FormHelperText>{fieldState.error.message}</FormHelperText>
                  )}
                </FormControlStyled>
              )}
              name="toPlace"
              control={control}
            />
            <ButtonBlue
              variant="contained"
              style={{ marginTop: "20px" }}
              onClick={() => {
                trigger("toPlace");
                const value = getValues("toPlace");
                if (value) {
                  setConfirmToPlace(true);
                }
              }}
            >
              ยืนยัน
            </ButtonBlue>
          </DivInputPlace>
        )}
        {watch("toPlace") !== undefined && confirmToPlace && siteScg && (
          <DivPlaceConfirm>
            <Typography variant="body1">
              {siteScg.map((value) => {
                if (value.idScgSite === watch("toPlace")) {
                  if (value.noSite !== null) {
                    return `Site${value.noSite}: ${value.nameSite}`;
                  } else {
                    return value.nameSite;
                  }
                }
              })}
            </Typography>
            <div style={{ display: "flex", gap: "20px" }}>
              <ButtonBlue
                variant="contained"
                customColor="#FF9800"
                sx={{
                  "&:hover": {
                    borderColor: "#de8500",
                    backgroundColor: "#de8500",
                  },
                }}
                onClick={() => setConfirmToPlace(false)}
              >
                เปลี่ยน
              </ButtonBlue>
              {confirmGettingPlace && confirmToPlace && (
                <ButtonBlue
                  variant="contained"
                  onClick={async () => {
                    if (User.roles.includes("ROLE_ADMIN") === true) {
                      const isValidId = await trigger("idRequester");
                      const isValidPhone = await trigger("phoneRequester");
                      const idValue = getValues("idRequester");
                      const phoneValue = getValues("phoneRequester");
                      if (isValidId && isValidPhone && idValue && phoneValue) {
                        handleSubmit(props.onClickNextPage)();
                      }
                    } else {
                      handleSubmit(props.onClickNextPage)();
                    }
                  }}
                >
                  ยืนยัน
                </ButtonBlue>
              )}
            </div>
          </DivPlaceConfirm>
        )}
      </DivPlace>
    </Fragment>
  );
};

export default AssignPlace;
